module.exports = __webpack_public_path__ + "static/media/sjrh.88138a73.svg";